import { IonButton, IonFab, IonIcon } from "@ionic/react";
import { add } from "ionicons/icons";

export const CreateDocumentButton = () => {
  return (
    <IonFab vertical="bottom" horizontal="end" slot="fixed">
      <IonButton routerLink={`/app/rrhh/acuerdos/crear`} color="secondary" size="large">
        <IonIcon icon={add} slot="start" />
        <span>Crear acuerdo</span>
      </IonButton>
    </IonFab>
  );
};
